import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class BlogtagService {
    constructor(private httpmanagerService: HttpManagerService) {
    }
    allBlogTag(): Promise<any> {
        return this.httpmanagerService.HttpGet('blogtag', "").then(data => {
            if (data) {
                return data.data;
            }
        })
    }
    iBlogPost(Post): Promise<any> {
        return this.httpmanagerService.HttpPost('blogpost', JSON.stringify(Post), "").then(data => {
            return data;
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/blogtag/blogtag.service.ts